import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { time } from "console";
import { DashboardService } from "src/app/services/events/dashboard.service";
import { environment } from "src/environments/environment";

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
})
export class SidenavComponent implements OnInit{
    public item_id: string;
    public isSidebarOpen: boolean = true;

    public menuItems: any[];
    public openedItemId: string;

    constructor(private router: Router, private dashboardEvent: DashboardService){}

    ngOnInit(): void {

      console.log(this.isSidebarOpen)


      this.dashboardEvent.isSidenavOpen.subscribe(data => this.isSidebarOpen = data)

      if (environment.appName === 'campanaragricola'){
        this.isSidebarOpen = true;
        this.dashboardEvent.menuItemData.shift()
      }
      this.menuItems = this.dashboardEvent.menuItemDataOld

    }

    toggleMenu(){
        this.isSidebarOpen = !this.isSidebarOpen
        if(this.isSidebarOpen){
            document.body.classList.add('no-scroll')
        }else{
            document.body.classList.remove('no-scroll')
        }
    }

    onNavItemClick(id: string){
     if (this.openedItemId === id) {
        this.openedItemId = null;
      } else {
        this.openedItemId = id;
      }
      //console.log(this.menuItems)
      this.dashboardEvent.onMenuItemClick(id);
    }

    onSubNavItemClick(id: string){
        this.dashboardEvent.onSubmenuItemClick(id)
        this.isSidebarOpen = false;
    }

}
